import { z } from "zod";

import http from "@/services/http";

const courseCompletion = z
  .object({
    courseCompletionDate: z.string().nullish(),
    courseCompletionEventID: z.string().nullish(),
    courseCompletionPercentage: z.string().nullish(),
    courseGUID: z.string().nullish(),
    courseID: z.string().nullish(),
    solomonuuid: z.string().nullish(),
    technology: z.string().nullish(),
    title: z.string().nullish(),
    vendorID: z.string().nullish(),
    pathStatus: z.string().nullish(),
  })
  .loose()
  .nullish();

const pathCompletion = z
  .object({
    pathCompletionDate: z.string().nullish(),
    pathCompletionStatus: z.string().nullish(),
    pathCompletionEventID: z.string().nullish(),
    pathProgressPercentage: z.string().nullish(),
    pathGUId: z.string().nullish(),
    pathId: z.string().nullish(),
    solomonuuid: z.string().nullish(),
    technology: z.string().nullish(),
    pathTitle: z.string().nullish(),
    vendorID: z.string().nullish(),
  })
  .loose()
  .nullish();

const tutorialCompletion = z
  .object({
    CompletionDate: z.string().nullish(),
    CompletionEventID: z.string().nullish(),
    CompletionPercentage: z.string().nullish(),
    GUID: z.string().nullish(),
    ID: z.string().nullish(),
    solomonuuid: z.string().nullish(),
    technology: z.string().nullish(),
    title: z.string().nullish(),
    vendorID: z.string().nullish(),
  })
  .loose()
  .nullish();

const practiceExamCompletion = z
  .object({
    CompletionDate: z.string().nullish(),
    CompletionEventID: z.string().nullish(),
    courseCompletionPercentage: z.string().nullish(),
    GUID: z.string().nullish(),
    ID: z.string().nullish(),
    solomonuuid: z.string().nullish(),
    technology: z.string().nullish(),
    title: z.string().nullish(),
    vendorID: z.string().nullish(),
  })
  .loose()
  .nullish();

const labCompletion = z
  .object({
    createdDate: z.string().nullish(),
    completionDate: z.string().nullish(),
    labGuid: z.string().nullish(),
    labModuleGuid: z.string().nullish(),
    orderNumber: z.string().nullish(),
    vendorId: z.string().nullish(),
  })
  .loose()
  .nullish();

const userProgressResponse = z.object({
  achievements: z.object({
    courses: z
      .object({
        completions: z.array(courseCompletion).nullish(),
        "In-progress": z.array(courseCompletion).nullish(),
      })
      .loose()
      .nullish(),
    learningpaths: z
      .object({
        "In-progress": z.array(pathCompletion).nullish(),
        completions: z.array(pathCompletion).nullish(),
        enrolled: z.array(pathCompletion).nullish(),
      })
      .loose()
      .nullish(),
    tutorials: z
      .object({
        completions: z.array(tutorialCompletion).nullish(),
        "In-progress": z.array(tutorialCompletion).nullish(),
      })
      .loose()
      .nullish(),
    practiceExams: z
      .object({
        completions: z.array(practiceExamCompletion).nullish(),
        "In-progress": z.array(z.any()).nullish(),
      })
      .loose()
      .nullish(),
    challenges: z
      .object({
        completions: z.array(courseCompletion).nullish(),
        "In-progress": z.array(courseCompletion).nullish(),
      })
      .loose()
      .nullish(),
    labs: z
      .object({
        completions: z.array(labCompletion).nullish(),
        "In-progress": z.array(labCompletion).nullish(),
      })
      .loose()
      .nullish(),
    assigned: z
      .array(
        z
          .object({
            createdAt: z.string().nullish(),
            guid: z.string().nullish(),
            id: z.string().nullish(),
            name: z.string().nullish(),
            type: z.string().nullish(),
          })
          .loose()
      )
      .nullish(),
  }),
});

export async function fetchUserProgress() {
  if (!globalThis.env.API_PROFILE) {
    return;
  }
  const { data } = await http().get(`${globalThis.env.API_PROFILE}/userProgress`);

  return userProgressResponse.parse(data);
}
